import { reducer } from './reducer';
import { sagas } from './sagas';


export * from './actions';
export * from './hooks';
export * from './sagas';
export * as DownloadsTypes from './types';

export const state = {
    reducer: {
        downloads: reducer,
    },
    sagas,
};
